import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL || '';

// Extract shop domain from URL (Shopify passes it as ?shop=xxx.myshopify.com)
const urlParams = new URLSearchParams(window.location.search);
const shopDomain = urlParams.get('shop') || '';

const api = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

// Automatically append ?shop= to every API request so the server
// can resolve the correct shopId even when the session is missing
api.interceptors.request.use((config) => {
  if (shopDomain) {
    config.params = { ...config.params, shop: shopDomain };
  }
  // FormData must use the browser-set multipart boundary — not application/json
  if (typeof FormData !== 'undefined' && config.data instanceof FormData) {
    if (config.headers && typeof config.headers.delete === 'function') {
      config.headers.delete('Content-Type');
    } else if (config.headers) {
      delete config.headers['Content-Type'];
    }
  }
  return config;
});

// ─── Attribute Groups ─────────────────────────────────────────────────────────
export const groupsApi = {
  getAll: () => api.get('/api/attributes/groups'),
  create: (data) => api.post('/api/attributes/groups', data),
  update: (id, data) => api.put(`/api/attributes/groups/${id}`, data),
  delete: (id) => api.delete(`/api/attributes/groups/${id}`),
};

// ─── Attributes ───────────────────────────────────────────────────────────────
export const attributesApi = {
  getAll: (params) => api.get('/api/attributes', { params }),
  getOne: (id) => api.get(`/api/attributes/${id}`),
  create: (data) => api.post('/api/attributes', data),
  update: (id, data) => api.put(`/api/attributes/${id}`, data),
  delete: (id) => api.delete(`/api/attributes/${id}`),
  toggle: (id) => api.patch(`/api/attributes/${id}/toggle`),
};

// ─── Products ─────────────────────────────────────────────────────────────────
export const productsApi = {
  getAll: () => api.get('/api/products'),
  getAttributes: (productId) => api.get(`/api/products/${productId}/attributes`),
  associate: (productId, data) => api.post(`/api/products/${productId}/attributes`, data),
  addAttribute: (productId, data) => api.post(`/api/products/${productId}/attributes/add`, data),
  removeAttribute: (productId, attributeId) =>
    api.delete(`/api/products/${productId}/attributes/${attributeId}`),
};

// ─── Orders ───────────────────────────────────────────────────────────────────
export const ordersApi = {
  getConfigurations: (params) => api.get('/api/products/orders/configurations', { params }),
};

export { api };
export default api;
